module.exports = "//public.getcloudapp.com/packs/media/images/markers/m_7-979ae4016072bce2b435b11a7a9ea3ec.svg";